module.exports = __webpack_public_path__ + "img/h51icon2.358ddcd1.png";